"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVAPMetrics = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var ASSET_NORMALIZED_ENGAGEMENT_METRIC_KEY = 'normalizedEngagement';
var useVAPMetrics = exports.useVAPMetrics = function useVAPMetrics() {
  var _React$useState = _react.default.useState({
      engagement: null
    }),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    vapMetrics = _React$useState2[0],
    setVAPMetrics = _React$useState2[1];
  var asset = (0, _exchangeReactHooks.useAsset)();
  var fetch = (0, _exchangeReactHooks.useFetch)();
  var tryFn = (0, _exchangeReactHooks.useTryFn)();
  _react.default.useEffect(function () {
    function init() {
      return _init.apply(this, arguments);
    } // eslint-disable-next-line @typescript-eslint/no-floating-promises
    function _init() {
      _init = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _json$asset$metrics$f, _json$asset;
        var response, json, engagement;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch("/api/v2/assets/".concat(asset.groupId, "/").concat(asset.assetId, "/metrics"));
            case 2:
              response = _context.sent;
              _context.next = 5;
              return response.json();
            case 5:
              json = _context.sent;
              engagement = (_json$asset$metrics$f = json === null || json === void 0 || (_json$asset = json.asset) === null || _json$asset === void 0 || (_json$asset = _json$asset.metrics.find(function (metric) {
                return metric.key === ASSET_NORMALIZED_ENGAGEMENT_METRIC_KEY;
              })) === null || _json$asset === void 0 ? void 0 : _json$asset.score) !== null && _json$asset$metrics$f !== void 0 ? _json$asset$metrics$f : 0;
              setVAPMetrics({
                engagement: engagement
              });
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _init.apply(this, arguments);
    }
    tryFn(function () {
      return init();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [asset.groupId, asset.assetId]);
  return vapMetrics;
};
//# sourceMappingURL=hooks.js.map